import type { TRule } from 'fela';
export const factoryNumber : TRule= () => ({
    textDecorationLine:"underline !important",
    textDecorationThickness: '0.1rem !important',
    ':hover': {
        color: '#f57645 !important',
    },
    color:'black !important',
})